// extracted by mini-css-extract-plugin
export default {"absolute":"styles_absolute__K9ztB","static":"styles_static__qKaFH","copy-button":"styles_copy-button__i20kw"};